// 491123 / 493427 — "é tablet ou celular?", pelo mesmo sinal que o CSS usa (`@media (hover: none)`
// em grid-itens.module.scss e tabelas.module.scss), e não por sniff de user-agent: `hover: none`
// descreve o ponteiro ATIVO de verdade, então um notebook com tela touch e mouse plugado continua
// contando como desktop, que é o que interessa na prática.
//
// Estava declarado dentro de GridItens.tsx; saiu para cá quando a segunda leitura apareceu
// (BarraRolagemHorizontalSuperior), para a resposta ser a mesma nos dois lugares.

// A MediaQueryList é criada uma vez e reaproveitada: `matches` é vivo (o navegador atualiza), então
// cachear o objeto não congela a resposta — só evita reprocessar a consulta a cada chamada, que
// importa em quem pergunta a cada quadro de rolagem.
let _consultaSemHover: MediaQueryList = undefined

export const dispositivoSemHover = () => {
    if (typeof window === "undefined" || !window.matchMedia) return false

    if (_consultaSemHover === undefined) _consultaSemHover = window.matchMedia("(hover: none)")

    return _consultaSemHover.matches
}

export default dispositivoSemHover
